import { BaseModel } from '/@/modules/core/app/models/abstracts/BaseModel';

export class Precision extends BaseModel {
  /**
   * @var {string}
   */
  type;

  /**
   * @var {string}
   */
  value;

  constructor({ type, value }) {
    super();

    this.type = type;
    this.value = value;
  }
}
